import React, {Component} from 'react';
import {injectIntl} from 'react-intl';
import {connect} from 'react-redux';
import {change, reduxForm, Field} from 'redux-form';
import PropTypes from 'prop-types';
import get from 'get-value';
import {StatusSelector, SubjectSelector} from '../../common/fields/UserNotificationSelectors';
import {StyledDiv} from '../../common/StyledComponents';
import ButtonSection from '../../common/userNotification/ButtonSection';
import formStatesMessages from '../../../intl/modules/formStatesMessages';
import notificationMessages from '../../../intl/modules/notificationMessages';

class NotificationCommercialForm extends Component {
    constructor(props) {
        super(props);
        const {initialValues, intl: {formatMessage}, subjectOptions} = this.props;
        this.state = {
            selectedStatuses: (initialValues.statuses || []).map(status => ({
                value: status,
                label: formStatesMessages[status] ? formatMessage(formStatesMessages[status]) : status
            })),
            selectedSubjects: (initialValues.subjects || []).map(subject => ({
                value: subject,
                label: get((subjectOptions || []).find(e => e.value === subject), `label`, subject)
            })),
        }
    }

    handleStatusChange = newOptions => {
        this.props.change(`statuses`, (newOptions || []).map(e => e.value));
        this.setState({
            selectedStatuses: (newOptions || []).map(status => ({
                value: status.value,
                label: status.label
            })),
        });
    };
    handleSubjectChange = newOptions => {
        this.props.change(`subjects`, (newOptions || []).map(e => e.value));
        this.setState({
            selectedSubjects: (newOptions || []).map(subject => ({
                value: subject.value,
                label: subject.label
            })),
        })
    };

    handleStatusAllClick = () => {
        this.props.change(`statuses`, (this.props.statusOptions || []).map(e => e.value));
        this.setState({selectedStatuses: this.props.statusOptions || []})
    };
    handleSubjectAllClick = () => {
        this.props.change(`subjects`, (this.props.subjectOptions || []).map(e => e.value));
        this.setState({selectedSubjects: this.props.subjectOptions || []})
    };

    handleCancel = () => {
        const {initialValues, intl: {formatMessage}, subjectOptions, reset} = this.props;
        reset();
        this.setState({
            selectedStatuses: (initialValues.statuses || []).map(status => ({
                value: status,
                label: formStatesMessages[status] ? formatMessage(formStatesMessages[status]) : status
            })),
            selectedSubjects: (initialValues.subjects || []).map(subject => ({
                value: subject,
                label: get((subjectOptions || []).find(e => e.value === subject), `label`, subject)
            })),
        })
    };

    render() {
        const {form, statusOptions, subjectOptions, handleSubmit, intl: {formatMessage}} = this.props;

        return (
            <StyledDiv className="border border-dark px-4 pt-3 pb-2 bg-light">
                {(statusOptions || []).length !== 0 &&
                <div>
                    <div className="row mb-3">
                        <div className="col">
                            <Field name={'statuses'}
                                   label={notificationMessages.STATUS_NOTIFICATION}
                                   component={StatusSelector}
                                   statuses={this.state.selectedStatuses}
                                   options={statusOptions}
                                   placeholder={formatMessage(notificationMessages.STATUS_PLACEHOLDER)}
                                   handleChange={this.handleStatusChange}
                                   handleAllClick={this.handleStatusAllClick}/>
                        </div>
                    </div>
                </div>
                }
                {(subjectOptions || []).length !== 0 &&
                <div>
                    <div className="row mb-3">
                        <div className="col">
                            <Field name={'subjects'}
                                   subjectKey={'commercial'}
                                   component={SubjectSelector}
                                   subjects={this.state.selectedSubjects}
                                   options={subjectOptions}
                                   placeholder={formatMessage(notificationMessages.SUBJECT_PLACEHOLDER)}
                                   handleChange={this.handleSubjectChange}
                                   handleAllClick={this.handleSubjectAllClick}/>
                        </div>
                    </div>
                </div>
                }
                <ButtonSection form={form}
                               onCancel={this.handleCancel}
                               onSubmit={handleSubmit}/>
            </StyledDiv>
        )
    }
}

NotificationCommercialForm.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    pristine: PropTypes.bool.isRequired,
    submitting: PropTypes.bool.isRequired,
    reset: PropTypes.func.isRequired,
    userDetail: PropTypes.object.isRequired,
    initialValues: PropTypes.object.isRequired,
    intl: PropTypes.object.isRequired,
};

const mapDispatchToProps = (dispatch, props) => ({
    change: (name, value) => dispatch(change(props.form, name, value)),
});

export default reduxForm({})(connect(null, mapDispatchToProps)(injectIntl(NotificationCommercialForm)));


